import { publicClient, privateClient } from './client';
import { RecentOrders } from './RecentOrders';

const customRecentOrders = (pub: boolean) => new RecentOrders(pub ? publicClient : privateClient);
export default customRecentOrders;
